<template>
  <div>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'orderNo')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.ORDER + 'orderNo'))"
                       v-model='queryParam.orderNo'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.CUSTOMER + 'custName')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.CUSTOMER + 'custName'))"
                       v-model='queryParam.aadhaarName'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'approvalStatus')">
              <dict-select
                v-model='queryParam.approvalStatus'
                :dict-code='DICT_CODE.ORDER_STATUS'
                :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <!--     结清状态-->
            <a-form-item :label="$t(I18N_KEY.ORDER + 'settleStatus')">
              <dict-select
                v-model='queryParam.settleStatus'
                :dict-code='DICT_CODE.SETTLE_STATUS'
                :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>
          <template v-if='toggleSearchStatus'>
            <a-col :md='12' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.APPROVAL + 'TaskSubTime')">
                <a-range-picker
                  v-model='queryParam.createdTime'
                  format='YYYY-MM-DD' />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
               <a @click='handleToggleSearch' style='margin-left: 8px'>
                     {{ $t(toggleSearchStatus ? 'hide' : 'show') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
        <Dict slot='approvalTaskStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_TASK_STATUS' :value='text' />
        <Dict slot='settleStatus' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
        <span slot='action' slot-scope='text, record'>
          <!-- slot-scope="text, record" -->
            <a @click='handleDetail(record)'>{{ $t('view') }}</a>
        </span>
        <template slot='mobileNoType' slot-scope='text, record'>{{ text.replace(/(\d{3})\d{4}(\d{3})/, '$1****$2') }}
        </template>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
    <v-modal
      v-model='visible'
      :title="$t('order.approvalDetail')">
      <div style='padding: 20px;'>
        <approval-detail
          v-if='visible'
          :orderId='orderId'
          :phoneprops='phoneprops'
          :custInfoId='custInfoId'
          :approvalStatus='approvalStatus'
          v-on:searchQuery='searchQuery'
          :taskId='taskId'
          v-on:closeDetail='closeDetail'
          @close='closeDetail' />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getMyTask } from '@/webpublicapi/approval'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import vModal from '../modules/Modal'
import ApprovalDetail from './ApprovalDetail'
import CryptoJS from 'crypto-js'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}

export default {
  name: 'MyApprovalTasks',
  components: {
    Dict,
    DictSelect,
    vModal,
    ApprovalDetail
  },
  data() {
    return {
      phoneprops:null,
      mobileNo: null,
      approvalStatus: undefined,
      settleStatus: undefined,
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      // 查询条件
      queryParam: {
        'orderNo': '',
        'approvalStatus': '',
        'settleStatus': '',
        'aadhaarName': '',
        'applyAmtMin': '',
        'applyAmtMax': '',
        'applyDate': undefined
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('order.orderNo'),
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: this.$t('customer.mobile'),
          align: 'left',
          dataIndex: 'mobileNo',
          scopedSlots: { customRender: 'mobileNoType' }
        },
        {
          title: this.$t('customer.custName'),
          align: 'left',
          dataIndex: 'aadhaarName'
        },
        {
          title: this.$t('order.applicationAmount'),
          align: 'left',
          dataIndex: 'applyAmt'
        },
        {
          title: this.$t('order.applicationDeadline'),
          align: 'left',
          dataIndex: 'duration'
        },
        {
          title: this.$t('approval.TaskSubTime'),
          align: 'left',
          dataIndex: 'shareOrderTime'
        },
        {
          title: this.$t('order.approvalTaskStatus'),
          align: 'left',
          dataIndex: 'approvalTaskStatus',
          scopedSlots: { customRender: 'approvalTaskStatus' }
        },
        {
          title: this.$t('order.settleStatus'),
          align: 'left',
          dataIndex: 'settleStatus',
          scopedSlots: { customRender: 'settleStatus' }
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.loadData(1)
  },
  mounted() {
    // 设置每10分钟发送一次请求
    this.interval = setInterval(this.refreshData, 10 * 60 * 1000);
  },
  methods: {
    refreshData(){
      let params ={"orderNo":"","approvalStatus":"","aadhaarName":"","applyAmtMin":"","applyAmtMax":"","pageNum":1,"pageSize":1}
      getMyTask(Object.assign({}, params)).then((res) => {
        console.log("10 min refresh ",this.dataSource[0].taskId === res.data.rows[0].taskId)
        if (!(this.dataSource[0].taskId === res.data.rows[0].taskId)){
          this.searchQuery()
        }
      })
    },
    // 解密方法
    decryptFun(encryptedBase64val, aesKeyval) {
      console.log('123123')
      const encryptedBase64 = encryptedBase64val // 替换为你的加密后的数据
      const aesKey = aesKeyval // 替换为你的 AES 密钥

      // 将密钥转换为 WordArray
      const key = CryptoJS.enc.Utf8.parse(aesKey)

      // 将 Base64 字符串转换为 WordArray
      const encrypted = CryptoJS.enc.Base64.parse(encryptedBase64)

      // 使用 AES 解密模式 ECB 进行解密
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encrypted },
        key,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      )

      // 将解密后的 WordArray 转换为字符串
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8)
      console.log('Decrypted Result:', decryptedText)
      return decryptedText
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    closeDetail() {
      this.visible = false
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      let params = this.getQueryParams()// 查询条件
      getMyTask(Object.assign({}, params)).then((res) => {
        const _this = this
        if (res.code === 1000) {
          const jiemidata = res.data.rows
          console.log('准备解密的数据', jiemidata)
          const doubledNumbers = jiemidata.map(function(item) {
            console.log('item', item.mobileNo)
            // let DecryptedNum = _this.decryptFun(item.mobileNo, 'f25b88c96a4538320c34b10b6107f73c') //加密号码，密钥
            let DecryptedNum = _this.decryptFun(item.mobileNo, process.env.VUE_APP_JIAMI)
            item.mobileNo = DecryptedNum //存储解密后的数据
          })
          console.log('doubledNumbers', doubledNumbers)
          console.log('解密后的数据', jiemidata)
          this.total = res.data.total
          this.dataSource = jiemidata
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    // getQueryParams () {
    //   const { applyDate } = this.queryParam;
    //   const data = {
    //       ...this.queryParam,
    //       applyDateStart: applyDate && this.transformTime(applyDate[0]),
    //       applyDateEnd: applyDate && this.transformTime(applyDate[1]),
    //   }
    //   delete data.applyDate;
    //   var param = Object.assign({}, data)
    //   param.pageNum = this.form.pageNum
    //   param.pageSize = this.form.pageSize
    //   return filterObj(param)
    // },
    getQueryParams() {
      console.log('this.queryParam', this.queryParam)
      // console.log('选择了日期吗', this.queryParam.createdTime.length)
      const data = {
        ...this.queryParam
      }
      const searchparam = Object.assign({}, data)
      if (this.queryParam.createdTime) {
        console.log('this.queryParam.createdTime.length', this.queryParam.createdTime.length)
        if (this.queryParam.createdTime.length) {
          console.log(this.queryParam.createdTime)
          console.log('选择了日期')
          const starttime = this.queryParam.createdTime[0]._d
          const endtime = this.queryParam.createdTime[1]._d
          const startDate1 = new Date(starttime).toISOString().split('T')[0]
          const endtime2 = new Date(endtime).toISOString().split('T')[0]
          searchparam.applyDateStart = startDate1
          searchparam.applyDateEnd = endtime2
        }
      }
      searchparam.pageNum = this.form.pageNum
      searchparam.pageSize = this.form.pageSize
      console.log('searchparam', searchparam)
      return searchparam
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.orderNo = ''
      that.queryParam.approvalStatus = ''
      that.queryParam.settleStatus = ''
      that.queryParam.aadhaarName = ''
      that.queryParam.applyDate = undefined
      that.queryParam.createdTime = ''
      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    handleDetail(row) {
      this.phoneprops = row.mobileNo
      this.orderId = row.orderId
      this.custInfoId = row.custInfoId
      this.taskId = row.taskId
      this.changeModal(true)
      this.approvalStatus = row.approvalStatus
    },
    afterAudit() {
      this.changeModal(false)
      this.loadData()
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
